// TODO: deprecate
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { SingleDatePicker } from 'react-dates'

import { useDispatch, useSelector } from 'react-redux'
import {
  setDepartureDate,
  setReturnDate
} from '../../../../redux/ferryRouteSelections/actions'
import * as UserSelectionActions from '../../../../redux/userSelections/actions'
import {
  selectDepartureDate,
  selectReturnDate
} from '../../../../redux/ferryRouteSelections/selectors'

import FerryRoutesFormDateSelect from './FerryRoutesFormDateSelect'

import moment from 'moment'
import { debounce } from 'lodash'
import { selectLanguage } from '../../../../redux/session/selectors'

const FerryRoutesFormSingleDatePicker = ({
  ferryLabels,
  startDate,
  disabled
}) => {
  const dispatch = useDispatch()
  const departureDate = useSelector(selectDepartureDate)
  const returnDate = useSelector(selectReturnDate)
  const language = useSelector(selectLanguage)
  const [focus, setFocus] = useState(false)

  const [calendarSize, setCalendarSize] = useState(
    window.innerWidth > 1024 ? 'lg' : 'sm'
  )

  function checkNumberOfMonths() {
    const size = window.innerWidth > 1024 ? 'lg' : 'sm'

    if (calendarSize !== size) {
      setCalendarSize(size)
    }
  }

  const debounced = debounce(checkNumberOfMonths, 100)

  useEffect(() => {
    window.addEventListener('resize', debounced)

    return () => {
      debounced.cancel()
      window.removeEventListener('resize', debounced)
    }
  })

  useEffect(() => {
    if (!startDate || moment(startDate).isSameOrBefore(departureDate)) {
      return
    }
    handleOnDateChange(moment(startDate))
  })

  const handleOnDateChange = date => {
    dispatch(setDepartureDate(moment(date))) // TODO: Deprecate
    dispatch(
      UserSelectionActions.setDepartureSearchDate(date.format('YYYY-MM-DD'))
    )
    if (returnDate) {
      dispatch(setReturnDate(null)) // TODO: Deprecate
      dispatch(UserSelectionActions.setReturnSearchDate(null))
    }
  }

  const toggleCustomDate = dateField => {
    const targetDatePicker = 'one-way-' + dateField
    document.getElementById(targetDatePicker).focus()
  }

  return departureDate ? (
    <div className="ferry-routes__form-single-date-picker">
      <SingleDatePicker
        block={true}
        date={departureDate ? departureDate.locale(language) : departureDate}
        daySize={36}
        displayFormat="MMM D, YYYY"
        disabled={disabled}
        focused={focus}
        horizontalMargin={30}
        id="one-way-departure"
        isOutsideRange={date =>
          date.isBefore(
            startDate && moment(startDate).isAfter(moment())
              ? moment(startDate)
              : moment()
          ) || date.isAfter(moment().add(18, 'months'))
        }
        navNext={<i className="material-icons">east</i>}
        navPrev={<i className="material-icons">west</i>}
        noBorder={true}
        numberOfMonths={1}
        onDateChange={handleOnDateChange}
        onFocusChange={() => {
          if (!focus) {
            const targetHeight = window.innerHeight + 400
            window.setTimeout(() => {
              window.scrollTo(0, targetHeight)
            }, 250)
          }

          setFocus(!focus)
        }}
        firstDayOfWeek={0}
        transitionDuration={0}
      />

      <div className="ferry-routes__form-single-date-picker-selects">
        <FerryRoutesFormDateSelect
          activeDateValue={departureDate}
          dateField="departure"
          ferryLabels={ferryLabels}
          fieldLabel={ferryLabels.departureDate}
          toggleDateEvent={toggleCustomDate}
          disabled={disabled}
        />
      </div>
    </div>
  ) : null
}

FerryRoutesFormSingleDatePicker.propTypes = {
  ferryLabels: PropTypes.shape(),
  startDate: PropTypes.string,
  disabled: PropTypes.bool
}

export default FerryRoutesFormSingleDatePicker
